@if (property) {
    <mat-card class="property-list-card-simple">
        <!-- (click)="viewProperty()" -->
        <!-- <div class="property-list-card-simple-image-container" [style.background]="'url(' + mainImg?.imageUrl + ')'" (click)="viewProperty()"></div> -->
         <div class="property-list-card-simple-image-container" 
            [style.background-image]="mainImg?.imageUrl ? 'url(' + mainImg?.imageUrl + ')' : 'none'" 
            (click)="viewProperty()">
        </div>
        <mat-card-content>
            <div class="property-simple-card-buttons">
                @defer {
                    <app-share-button [propertyTitle]="getPropertyTitle()" [propertyUrl]="getPropertyUrl()" theme="light"></app-share-button>
                    <app-save-button
                        [propertyId]="property.id" 
                        [isLiked]="property.liked"
                        (likedChange)="property.liked = $event">
                    </app-save-button>
                }
                <!-- <button mat-icon-button type="button" (click)="shareProperty()">
                    <mat-icon>ios_share</mat-icon>
                </button> -->
                <!-- <button mat-icon-button 
                    class="like-button" 
                    [class.liked]="property?.liked ?? false"
                    (click)="toggleLike($event)">
                    <mat-icon>favorite</mat-icon>
                </button> -->
            </div>
            <div class="property-simple-card-heading">
                {{property.displayName ?? property.propertyType | titlecase }} in {{property.address.city}}, {{property.address.state}}
            </div>

            <div class="property-details">
                <div class="property-address">
                    <span class="property-address-address">
                    </span>
                </div>

                <div class="property-detail">
                    <div class="icon-with-label">
                        <span class="material-symbols-outlined" matTooltip="Property Type">house</span> 
                        <span>{{ property.propertyType | titlecase }}</span>
                    </div>
                    
                    <div class="icon-with-label">
                        <span class="material-symbols-outlined" matTooltip="Square Footage">square_foot</span>
                        <span>{{ property.sizeSqft + ' ft²'}}</span>
                    </div>

                    <div class="icon-with-label">
                        <span class="material-symbols-outlined" matTooltip="Bedrooms">bed</span>
                        <span class="bedrooms-text">
                            {{ property.bedrooms || 'N/A' }}
                            <span class="sleeps-part" [attr.data-sleeps]="property.sleeps">
                                {{ property.sleeps ? ' (sleeps ' + property.sleeps + ')' : '' }}
                            </span>
                        </span>
                    </div>

                    <div class="icon-with-label">
                        <span class="material-symbols-outlined" matTooltip="Bathrooms">bathtub</span>
                        <span>
                            {{ property.bathrooms || 'N/A' }}
                            <span class="bathrooms-text"></span>
                        </span>
                    </div>
                </div>
            </div>

            @if (property.cost) {
                <div class="property-cost"><i>starting at</i> {{ property.cost | currency }} per night</div>
            }
        </mat-card-content>
    </mat-card>

    <!-- 🔥 FULL-SCREEN IMAGE VIEWER MODAL -->
    <div class="image-viewer-overlay" *ngIf="showImageViewer">
        <div class="image-viewer-container">
            <!-- Close Button -->
            <button mat-icon-button class="close-button" (click)="closeImageViewer()">
                <mat-icon>close</mat-icon>
            </button>
            
            <!-- Main Image (Centered) -->
            <div class="main-image-container">
                <img [src]="viewerImageUrl" 
                    [alt]="viewerImageDescription"
                    class="viewer-image" />
            </div>
            
            <!-- Navigation Arrows -->
            @if (property && property.images && property.images.length > 1) {
                <button class="nav-button prev" (click)="prevImage()">
                    <mat-icon>chevron_left</mat-icon>
                </button>
                <button class="nav-button next" (click)="nextImage()">
                    <mat-icon>chevron_right</mat-icon>
                </button>
            }
            
            <!-- Image Counter -->
            @if (property && property.images && property.images.length > 1) {
                <div class="image-counter">
                    {{ currentImageIndex + 1 }} / {{ property.images.length }}
                </div>
            }
        </div>
    </div>
} @else {
    <app-loader></app-loader>>
}
